export type DisclaimerCategory = keyof typeof disclaimerAccordions;

export const disclaimerAccordions = {
  nbn: {
    label: "Things to know about our nbn® plans",
    url: "#controller-things-to-know-about-our-nbn-plans",
  },
  mobile: {
    label: "Things to know about our mobile SIM plans",
    url: "#controller-things-to-know-about-our-mobile-sim-plans",
  },
  promo: {
    label: "Things to know about our promotions",
    url: "#controller-things-to-know-about-our-promotions",
  },
};

interface Disclaimer {
  category: DisclaimerCategory;
  text: string;
}

export const useDisclaimerStore = defineStore("disclaimerStore", () => {
  const disclaimers = ref<Partial<Record<DisclaimerCategory, string[]>>>({});

  const addDisclaimers = (newDisclaimers: Disclaimer[]) => {
    newDisclaimers.forEach(({ category, text }) => {
      if (!disclaimers.value[category]) {
        disclaimers.value[category] = [text];
        return;
      }
      if (!disclaimers.value[category].includes(text)) {
        disclaimers.value[category].push(text);
      }
    });
  };

  // This is called automatically on route change in middleware/disclaimers.global.ts
  const clearDisclaimers = () => (disclaimers.value = {});

  return {
    disclaimers,
    addDisclaimers,
    clearDisclaimers,
  };
});
